import { useStore } from '@/store'

export function initEmptyParam() {
  const store = useStore()
  store.commit('system/changeQueyryInfo', {})
}
